<template>
	<div id="vx-col w-full mb-base">
		<BigQueryPopup
			:popupActive="showBigQueryPopup"
			@close-popup="showBigQueryPopup = false"
		/>

		<vx-card title="Exports">
			<vs-table :data="exports">
				<template slot="thead">
					<vs-th>Export</vs-th>
					<vs-th>Actions</vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr :key="index" v-for="(tr, index) in data">
						<vs-td>{{ tr.name }}</vs-td>
						<vs-td>
							<vs-button
								size="large"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-eye"
								@click="openExportPopup(tr.slug)"
							></vs-button>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</vx-card>
	</div>
</template>

<script>
import BigQueryPopup from "@/components/popups/BigQueryPopup.vue";

export default {
	name: "ExportsDashboard",
	components: {
		BigQueryPopup,
	},
	data() {
		return {
			showBigQueryPopup: false,
			exports: [
				{
					name: "Big Query",
					slug: "big_query",
				},
			],
		};
	},
	methods: {
		openExportPopup(slug) {
			if (slug === "big_query") {
				this.showBigQueryPopup = true;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.text-right {
	text-align: right !important;
}
</style>
